import { render } from "./TextField.vue?vue&type=template&id=5b9a0853&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"

import "./TextField.vue?vue&type=style&index=0&id=5b9a0853&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9a0853"]])

export default __exports__